// Kitchen parts: ids match the photo's material mask (public/scenes/kitchen-mask.json). Labels and groups feed the tour controls.
const p = (id, label, group) => ({ id, label, group });

export const KITCHEN_PARTS = [
  p("ceiling", "Ceiling", "ceiling"),
  p("leftWall", "Left wall", "wall"),
  p("backWall", "Back wall", "wall"),
  p("rightWall", "Window wall", "wall"),
  p("floor", "Floor", "floor"),
  p("baseboards", "Baseboards", "trim"),
  p("crown", "Crown molding", "trim"),
  p("doorTrim", "Door casing", "trim"),
  p("hallDoor", "Hallway door", "door"),
  p("windowTrim", "Window trim", "trim"),
  p("backsplash", "Backsplash", "backsplash"),
  p("hood", "Range hood", "hood"),

  p("upperFrame", "Upper cabinet frames", "upper"),
  p("u1", "Upper door 1", "upper"),
  p("u2", "Upper door 2", "upper"),
  p("u3", "Upper door 3", "upper"),
  p("uh1", "Above-hood door (left)", "upper"),
  p("uh2", "Above-hood door (right)", "upper"),
  p("u4", "Upper door 4", "upper"),
  p("u5", "Upper door 5", "upper"),
  p("u6", "Upper door 6", "upper"),
  p("uf1", "Above-fridge door (left)", "upper"),
  p("uf2", "Above-fridge door (right)", "upper"),

  p("pantryFrame", "Pantry frame & fridge panel", "pantry"),
  p("p1", "Pantry door, top left", "pantry"),
  p("p2", "Pantry door, top right", "pantry"),
  p("p3", "Pantry door, middle left", "pantry"),
  p("p4", "Pantry door, middle right", "pantry"),
  p("p5", "Pantry door, bottom left", "pantry"),
  p("p6", "Pantry door, bottom right", "pantry"),

  p("lowerFrame", "Lower cabinet frames", "lower"),
  p("ld1", "Lower drawer 1", "lower"),
  p("ld2", "Lower drawer 2", "lower"),
  p("ld3", "Lower drawer 3", "lower"),
  p("ld4", "Lower drawer 4", "lower"),
  p("l1", "Lower door 1", "lower"),
  p("l2", "Lower door 2", "lower"),
  p("l3", "Lower door 3", "lower"),
  p("l4", "Lower door 4", "lower"),
  p("counterBack", "Back countertop", "counter"),

  p("islandFrame", "Island frame & end panels", "island"),
  p("iad", "Island drawer 1", "island"),
  p("ia", "Island door 1", "island"),
  p("ibd", "Island drawer 2", "island"),
  p("ib", "Island door 2", "island"),
  p("icd", "Island drawer 3", "island"),
  p("ic", "Island door 3", "island"),
  p("ishelf", "Island open shelf", "island"),
  p("idd", "Island drawer 4", "island"),
  p("counterIsland", "Island countertop", "counter"),
];

export const KITCHEN_GROUPS = [
  { id: "walls", label: "All walls", match: ["wall"], help: "Left, back and window walls together." },
  { id: "ceiling", label: "Ceiling", match: ["ceiling"], help: "The ceiling, around the recessed lights." },
  { id: "cabinets", label: "All cabinets", match: ["upper", "pantry", "lower", "island"], help: "Every cabinet door, drawer and frame, including the island." },
  { id: "upper", label: "Upper cabinets", match: ["upper"], help: "The wall cabinets above the counter, the hood and the fridge." },
  { id: "lower", label: "Lower cabinets", match: ["lower"], help: "The base cabinets and drawers along the back wall." },
  { id: "pantry", label: "Pantry", match: ["pantry"], help: "The tall pantry and the panel beside the fridge." },
  { id: "island", label: "Island", match: ["island"], help: "Island doors, drawers, open shelf and frame." },
  { id: "trim", label: "Trim & molding", match: ["trim"], help: "Crown molding, baseboards, door casing and window trim." },
  { id: "hallDoor", label: "Hallway door", match: ["door"], help: "The panel door on the left wall." },
  { id: "counters", label: "Countertops", match: ["counter"], help: "Back counter and island top." },
  { id: "backsplash", label: "Backsplash", match: ["backsplash"], help: "The tiled wall behind the counter and range." },
  { id: "hood", label: "Range hood", match: ["hood"], help: "The stainless hood above the range." },
  { id: "floor", label: "Floor", match: ["floor"], help: "The wood floor finish." },
];
